var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
    stroke: "#24A95D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97333 8.06738C5.97333 7.61165 6.02867 7.2487 6.13935 6.97852C6.25002 6.70833 6.45185 6.44303 6.74482 6.18262C7.04104 5.91895 7.23798 5.70573 7.33564 5.54297C7.43329 5.37695 7.48212 5.2028 7.48212 5.02051C7.48212 4.47038 7.22821 4.19531 6.7204 4.19531C6.47952 4.19531 6.28583 4.27018 6.13935 4.41992C5.99612 4.56641 5.92125 4.76986 5.91474 5.03027H4.49872C4.50523 4.40853 4.70543 3.92188 5.09931 3.57031C5.49644 3.21875 6.03681 3.04297 6.7204 3.04297C7.41051 3.04297 7.94599 3.21061 8.32685 3.5459C8.70771 3.87793 8.89814 4.34831 8.89814 4.95703C8.89814 5.23372 8.83629 5.49577 8.71259 5.74316C8.58889 5.9873 8.37242 6.25911 8.06318 6.55859L7.66767 6.93457C7.42027 7.1722 7.27867 7.45052 7.24286 7.76953L7.22333 8.06738H5.97333ZM5.83173 9.56641C5.83173 9.34831 5.90497 9.16927 6.05146 9.0293C6.2012 8.88607 6.39163 8.81445 6.62275 8.81445C6.85387 8.81445 7.04267 8.88607 7.18915 9.0293C7.33889 9.16927 7.41376 9.34831 7.41376 9.56641C7.41376 9.78125 7.34052 9.95866 7.19404 10.0986C7.05081 10.2386 6.86038 10.3086 6.62275 10.3086C6.38512 10.3086 6.19306 10.2386 6.04657 10.0986C5.90335 9.95866 5.83173 9.78125 5.83173 9.56641Z",
    fill: "#24A95D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.a1cfdefad3e567a17a91fc9988841e79.svg";
export { ForwardRef as ReactComponent };